import CourseBatchList from './CourseBatchList';

export default CourseBatchList; 